export default __webpack_public_path__ + "static/media/doubleclick.594028b4.svg";